import * as React from "react";
import {
  IBenchmarkItem,
  ToggableButton,
} from "../ToggableButton/ToggableButton";
import s from "./ToggableBenchmarkItems.module.scss";
import cn from "classnames";
import PlusButton from "../ToggableButton/PlusButton";

interface IProps {
  benchmarks: IBenchmarkItem[];
  activeBenchmarks: Array<string>;
  onPress: (key: string) => void;
  onDelete: (e: React.MouseEvent<SVGElement, MouseEvent>, key: string) => void;
  onPlusPress: () => void;
  generating?: boolean;
}

const ToggableBenchmarkItems = ({
  benchmarks,
  activeBenchmarks,
  onPress,
  onPlusPress,
  onDelete,
  generating,
}: IProps) => {
  console.log({ benchmarks });
  return (
    <div className={cn(s.container, generating && s.generating)}>
      {benchmarks.map((benchmarkItem, idx: number) =>
        !!benchmarkItem?.label ? (
          <ToggableButton
            key={idx}
            active={activeBenchmarks.includes(benchmarkItem.value)}
            item={benchmarkItem}
            onPress={onPress}
            onDelete={onDelete}
            hide={
              generating &&
              !(benchmarkItem as any).active &&
              !activeBenchmarks.includes(benchmarkItem.value)
            }
          />
        ) : null
      )}
      {!generating && <PlusButton onPress={onPlusPress} />}
    </div>
  );
};

export default ToggableBenchmarkItems;
